import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Identity/Login";
import Dashboard from "./components/pages/dashboard/Dashboard";
import MasterQuizzes from "./components/pages/quiz/master/MasterQuizzes";
import MasterAssessment from "./components/pages/assessments/masters/MasterAssessment";
import CreateAssessment from "./components/pages/assessments/masters/CreateAssessment";
import AssessmentMCQAttendees from "./components/pages/assessments/masters/AssessmentAttendees";
import QuizExam from "./components/pages/quiz/exam/QuizExam";
import ViewQuizExam from "./components/pages/quiz/master/ViewQuizExam";
import UploadQuizMCQ from "./components/pages/quiz/master/UploadQuizMCQ";
import AssessmentExam from "./components/pages/assessments/exam/AssessmentExam";
import AssessmentQuestions from "./components/pages/assessments/masters/AssessmentQuestions";
import UploadAssessmentQuestion from "./components/pages/assessments/masters/UploadAssessmentQuestion";
import AssessmentSessions from "./components/pages/assessments/masters/AssessmentSessions";
import ViewAssessmentExam from "./components/pages/assessments/masters/ViewAssessmentExam";
import QuizAttendees from "./components/pages/quiz/master/QuizAttendees";
import QuizSessions from "./components/pages/quiz/master/QuizSession";
import QuizQuestions from "./components/pages/quiz/master/QuizQuestions";
import TwoFactorVerify from "./components/Identity/QrCode";
import MfaVerify from "./components/Identity/MfaVerify";
import Reset from "./components/Identity/Reset";
import EmailOtpVerify from "./components/Identity/EmailVerifyOTP";
import ResetPassword from "./components/Identity/ResetPassword";
import ForgotPassword from "./components/Identity/ForgotPassword";
import ProtectedRoute from "./auth/ProtectedRoute";
import Logout from "./components/pages/logout/Logout";
import Alert from "./components/alert/Alert";
import CampaignDashboard from "./components/pages/campaigns/CampaignsDashboard";
import StatsCards from "./components/pages/knowledgeDocuments/KnowledgeDashboard";
import Topics from "./components/pages/knowledgeDocuments/Topics";
import SubTopicVideos from "./components/pages/knowledgeDocuments/SubTopicVideos";
import VideoStream from "./components/pages/knowledgeDocuments/VideoStream";
import SupportDashboard from "./components/pages/support/SupportDashboard";
import Faq from "./components/pages/faq/FAQ";
import AssessmentDemoCard from "./components/pages/assessments/exam/AssessmentDemoCard";
import QuizDemoCard from "./components/pages/quiz/exam/QuizDemoCard";
import CreateTopic from "./components/pages/knowledgeDocuments/CreateTopic";
import CreateSubTopic from "./components/pages/knowledgeDocuments/CreateSubTopic";
import MainLayout from "./components/layout/MainLayouts";



export default function App() {
  return (
    <>
      <Alert />
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/resetpassword/:code" element={<ResetPassword />} />

        {/* (PROTECTED) */}
        <Route
          path="/qrcode"
          element={
            <ProtectedRoute>
              <TwoFactorVerify />
            </ProtectedRoute>
          }
        />

        <Route
          path="/mfa"
          element={
            <ProtectedRoute>
              <MfaVerify />
            </ProtectedRoute>
          }
        />

        <Route
          path="/email-verify-otp"
          element={
            <ProtectedRoute>
              <EmailOtpVerify />
            </ProtectedRoute>
          }
        />

        <Route
          path="/reset"
          element={
            <ProtectedRoute>
              <Reset />
            </ProtectedRoute>
          }
        />

        {/* MAIN APP (PROTECTED LAYOUT) */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout/>
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" />} />
          <Route path="dashboard" element={<Dashboard />} />

          {/* Videos Section*/}
          <Route path="knowledge-management" element={<StatsCards />} />
          <Route path="knowledge-management/topics" element={<Topics />} />
          <Route
            path="knowledge-management/topics/:topicId"
            element={<SubTopicVideos />}
          />
          <Route
            path="knowledge-management/topics/:topicId/video/:videoId"
            element={<VideoStream />}
          />
          <Route
            path="knowledge-management/topics/:topicId/video/:videoId/quiz"
            element={<QuizExam />}
          />
          <Route
            path="knowledge-management/topics/:topicId/assessment"
            element={<AssessmentExam />}
          />
          <Route
            path="knowledge-management/topics/add"
            element={<CreateTopic />}
          />
          <Route
            path="knowledge-management/topics/:topicId/edit"
            element={<CreateTopic />}
          />
          <Route
            path="knowledge-management/topics/add-sub-topic"
            element={<CreateSubTopic />}
          />
          <Route
            path="knowledge-management/topics/:topicId/:subTopicId/edit-sub-topic"
            element={<CreateSubTopic />}
          />

          {/* dummy data */}
          <Route path="campaigns" element={<CampaignDashboard />} />
          <Route path="assessment" element={<AssessmentDemoCard />} />
          <Route path="quiz" element={<QuizDemoCard />} />
          <Route path="support" element={<SupportDashboard />} />
          <Route path="faq" element={<Faq />} />

          {/* Masters */}
          <Route path="masters-assessments" element={<MasterAssessment />} />
          <Route
            path="masters-assessments/add"
            element={<CreateAssessment />}
          />
          <Route
            path="masters-assessments/:assessmentId"
            element={<CreateAssessment />}
          />
          <Route
            path="masters-assessments/:id/questions"
            element={<AssessmentQuestions />}
          />
          <Route
            path="masters-assessments/:id/questions/import"
            element={<UploadAssessmentQuestion />}
          />
          <Route
            path="masters-assessments/:assessmentId/sessions"
            element={<AssessmentSessions />}
          />
          <Route
            path="masters-assessments/:assessmentId/attendees"
            element={<AssessmentMCQAttendees />}
          />
          <Route
            path="masters-assessments/:assessmentId/attendees/:attendeeId"
            element={<ViewAssessmentExam />}
          />

          <Route path="masters-quizzes" element={<MasterQuizzes />} />
          <Route
            path="masters-quizzes/:id/questions"
            element={<QuizQuestions />}
          />
          <Route
            path="masters-quizzes/:id/questions/import"
            element={<UploadQuizMCQ />}
          />
          <Route
            path="masters-quizzes/:id/attendees"
            element={<QuizAttendees />}
          />
          <Route
            path="masters-quizzes/:id/sessions"
            element={<QuizSessions />}
          />
          <Route
            path="masters-quizzes/:id/attendees/:attendeeId"
            element={<ViewQuizExam />}
          />
          <Route path="/logout" element={<Logout />} />
        </Route>
        {/* 404 */}
        <Route path="*" element={<h5>Page Not Found</h5>} />
      </Routes>
    </>
  );
}
